<template>
  <div id="card-form-container" class="card-form-container" />
</template>

<script>
export default {
  name: 'SolidGateCard',
  data: () => ({
    form: null,
  }),
  computed: {
    solidGatePaymentIntent() {
      return this.$store.getters.solidGatePaymentIntent;
    },
    signature() {
      return this.$store.getters.solidGatePaymentIntentSignature;
    },
    merchantData() {
      const { solidgate_data } = this.solidGatePaymentIntent;

      return {
        merchant: solidgate_data.merchant_id,
        signature: solidgate_data.signature,
        paymentIntent: solidgate_data.payment_intent,
      };
    },
  },
  watch: {
    signature(newSignature, oldSignature) {
      // Update the wallet form if the signature changes
      if (newSignature !== oldSignature) {
        this.initCard();
      }
    },
  },
  mounted() {
    // Initialize the wallet form last
    // this is a workaround for the issue with the iframe not loading properly
    // when the component is mounted
    // and the form is not ready yet.
    this.$nextTick(() => {
      this.initCard();
    });
  },
  destroyed() {
    if (this.form) {
      this.destroyForm();
    }
  },
  methods: {
    destroyForm() {
      if (this.form) {
        this.form.unsubscribeAll();
        this.form = null;
      }
    },
    initCard() {
      const merchantId = this.merchantData.merchant;
      if (!merchantId) {
        console.warn('Merchant ID is not available');
        return;
      }

      const data = {
        merchantData: this.merchantData,
        iframeParams: {
          width: '100%',
          containerId: 'card-form-container',
        },
        formParams: {
          enabled: true,
        },
        googlePayButtonParams: {
          enabled: false,
        },
        applePayButtonParams: {
          enabled: false,
        },
        styles: {
          googleFontLink:
            'https://fonts.googleapis.com/css2?family=Noto+Sans+Symbols:wght@100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"',
          submit_button: {
            display: 'none',
          },
          form_body: {
            'font-size': '14px',
          },
          input_group: {
            'font-size': '14px',
            input: {
              'background-color': '#F6F8FA',
              'border-color': '#F6F8FA',
              color: 'black',
              ':focus': {
                'border-color': '#F6F8FA',
              },
              '::placeholder': {
                color: '#77787e',
              },
            },
          },
          card_cvv: {
            input: {
              'background-color': '#F6F8FA',
              'border-color': '#F6F8FA',
              color: 'black',
              ':focus': {
                'border-color': '#F6F8FA',
              },
              '::placeholder': {
                color: '#77787e',
                'font-size': '14px',
              },
            },
          },
        },
      };
      // eslint-disable-next-line no-undef
      const form = PaymentFormSdk.init(data);

      form.on('success', data => {
        this.$emit('on-success', data);
        this.$store.dispatch('resetSolidGatePaymentIntent');
        this.destroyForm();
      });
      form.on('fail', error => {
        this.$emit('on-error', error.data);
      });
      form.on('error', error => {
        this.$emit('on-error', error.data);
      });

      this.form = form;
    },
    submit() {
      this.form?.submit();
    },
  },
};
</script>

<style scoped lang="scss">
.card-form-container {
  iframe {
    border: none !important;
  }
}
</style>
